webpackJsonp([43369700788870],{

/***/ 210:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jquery = __webpack_require__(108);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _sectionTitle = __webpack_require__(14);
	
	var _sectionTitle2 = _interopRequireDefault(_sectionTitle);
	
	var _button = __webpack_require__(29);
	
	var _button2 = _interopRequireDefault(_button);
	
	__webpack_require__(166);
	
	var _reactFontawesome = __webpack_require__(10);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	var _fontawesomeFreeSolid = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Contactform = function (_React$Component) {
	    _inherits(Contactform, _React$Component);
	
	    function Contactform(props) {
	        _classCallCheck(this, Contactform);
	
	        return _possibleConstructorReturn(this, _React$Component.call(this, props));
	    }
	
	    Contactform.prototype.componentDidMount = function componentDidMount() {
	        var $submitBtn = (0, _jquery2.default)('.contact__form .btn');
	        var emailValidate = function emailValidate(email) {
	            var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
	            return emailReg.test(email);
	        };
	
	        $submitBtn.on('click', function (e) {
	            e.preventDefault();
	
	            var $name = (0, _jquery2.default)('.name');
	            var $email = (0, _jquery2.default)('.email');
	            var $phone = (0, _jquery2.default)('.phoneno');
	            var $message = (0, _jquery2.default)('.message');
	
	            $name.removeClass('is-err');
	            $email.removeClass('is-err');
	            $message.removeClass('is-err');
	            (0, _jquery2.default)('.err-text').html('');
	            $submitBtn.addClass('disabled');
	
	            var errors = false;
	            if (!$name.val()) {
	                $name.addClass('is-err');
	                errors = true;
	            }
	
	            if (!$email.val()) {
	                $email.addClass('is-err');
	                errors = true;
	            }
	
	            if (!$message.val()) {
	                $message.addClass('is-err');
	                errors = true;
	            }
	
	            if (errors) {
	                (0, _jquery2.default)('.err-text').html('You have errors. Please check all the required fields.');
	                $submitBtn.removeClass('disabled');
	                return;
	            }
	
	            if (!emailValidate($email.val())) {
	                (0, _jquery2.default)('.err-text').html('Invalid Email address');
	                $submitBtn.removeClass('disabled');
	                return;
	            }
	
	            var data = {
	                name: $name.val(),
	                emailId: $email.val(),
	                contact: $phone.val(),
	                message: $message.val()
	            };
	            _jquery2.default.post('http://api.akgdynamics.co.uk/revaschildcare/contact_request', data);
	            (0, _jquery2.default)('.contact__form').addClass('is-submitted');
	            setTimeout(function () {
	                (0, _jquery2.default)('.contact__form').addClass('is-visible');
	            }, 10);
	        });
	    };
	
	    Contactform.prototype.render = function render() {
	        return _react2.default.createElement(
	            'section',
	            { className: 'contact__form' },
	            _react2.default.createElement(
	                'div',
	                { className: 'form__data' },
	                _react2.default.createElement(_sectionTitle2.default, { title: 'Reach out to us' }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'rc-copy' },
	                    'Let\'s get the conversation started, send us your contact details and we\'ll get back to you.'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'form' },
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement('input', { className: 'form-control name', placeholder: 'Name' })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement('input', { className: 'form-control email', placeholder: 'Email Address' })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement('input', { className: 'form-control phoneno', placeholder: 'Phone Number (Optional)' })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement('textarea', { className: 'form-control message', placeholder: 'Mesage' })
	                    ),
	                    _react2.default.createElement(_button2.default, { text: 'Submit', action: 'true' }),
	                    _react2.default.createElement('div', { className: 'err-text' })
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'form__success' },
	                _react2.default.createElement(_reactFontawesome2.default, { icon: _fontawesomeFreeSolid.faCheckCircle }),
	                _react2.default.createElement(_sectionTitle2.default, { title: 'Thank you for your message' }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'rc-copy' },
	                    'We will get back to you as soon as possible.'
	                )
	            )
	        );
	    };
	
	    return Contactform;
	}(_react2.default.Component);
	
	exports.default = Contactform;
	module.exports = exports['default'];

/***/ }),

/***/ 211:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _sectionTitle = __webpack_require__(14);
	
	var _sectionTitle2 = _interopRequireDefault(_sectionTitle);
	
	__webpack_require__(166);
	
	var _reactFontawesome = __webpack_require__(10);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	var _fontawesomeFreeSolid = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Logo = function Logo() {
	    return _react2.default.createElement(
	        'section',
	        { className: 'contact__map' },
	        _react2.default.createElement(
	            'div',
	            { className: 'contact__map__details' },
	            _react2.default.createElement(
	                'div',
	                { className: 'container' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'text rc-copy' },
	                    _react2.default.createElement(_sectionTitle2.default, { title: 'Find Us at', icon: _fontawesomeFreeSolid.faMapMarker, color: 'yellow' }),
	                    '373 Meadow Lane',
	                    _react2.default.createElement('br', null),
	                    'Oxford',
	                    _react2.default.createElement('br', null),
	                    'OX4 4BL'
	                )
	            )
	        )
	    );
	};
	
	exports.default = Logo;
	module.exports = exports['default'];

/***/ }),

/***/ 483:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/reva.ec7c38a2.jpg";

/***/ }),

/***/ 220:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(17);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _banner = __webpack_require__(46);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	var _contactmap = __webpack_require__(211);
	
	var _contactmap2 = _interopRequireDefault(_contactmap);
	
	var _contactform = __webpack_require__(210);
	
	var _contactform2 = _interopRequireDefault(_contactform);
	
	var _sectionTitle = __webpack_require__(14);
	
	var _sectionTitle2 = _interopRequireDefault(_sectionTitle);
	
	var _reva = __webpack_require__(483);
	
	var _reva2 = _interopRequireDefault(_reva);
	
	var _reactFontawesome = __webpack_require__(10);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	var _fontawesomeFreeSolid = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Contact = function Contact() {
		return _react2.default.createElement(
			'div',
			null,
			_react2.default.createElement(_banner2.default, { type: 'contactus', title: 'Contact Us' }),
			_react2.default.createElement(
				'section',
				{ className: 'page-grid' },
				_react2.default.createElement(
					'section',
					{ className: 'container contact__content page-grid-section' },
					_react2.default.createElement(
						'div',
						{ className: 'row' },
						_react2.default.createElement(
							'div',
							{ className: 'col-md-5' },
							_react2.default.createElement(
								'div',
								{ className: 'contact__childminder' },
								_react2.default.createElement('img', { src: _reva2.default, alt: 'Reva Garewal' }),
								_react2.default.createElement(
									'div',
									{ className: 'text' },
									_react2.default.createElement(_sectionTitle2.default, { title: 'Reva Garewal' }),
									_react2.default.createElement(
										'div',
										{ className: 'rc-copy' },
										'Registered Childminder'
									),
									_react2.default.createElement(
										'div',
										{ className: 'rc-copy' },
										'Registered ID: EY461588'
									),
									_react2.default.createElement(
										'div',
										{ className: 'small-text' },
										_react2.default.createElement(
											'span',
											{ className: 'phone' },
											_react2.default.createElement(_reactFontawesome2.default, { icon: _fontawesomeFreeSolid.faPhoneSquare }),
											' 07863 337472'
										),
										_react2.default.createElement(
											'span',
											null,
											_react2.default.createElement(_reactFontawesome2.default, { icon: _fontawesomeFreeSolid.faEnvelope }),
											' revasotra@hotmail.com'
										)
									)
								)
							)
						),
						_react2.default.createElement(
							'div',
							{ className: 'col-md-7' },
							_react2.default.createElement(_contactform2.default, null)
						)
					)
				),
				_react2.default.createElement(_contactmap2.default, null)
			)
		);
	};
	
	exports.default = Contact;
	module.exports = exports['default'];

/***/ }),

/***/ 166:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-us-js-6a2b78e95e8fc39b3726.js